import * as React from 'react';

const SvgPills = props => (
  <svg
    data-name="Group 1838"
    height={40.44}
    viewBox="0 0 42.121 40.44"
    width={42.121}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* <defs>
      <clipPath id="Pills_svg__a">
        <path
          d="M0 0h42.121v40.44H0z"
          data-name="Rectangle 377"
          fill="#fff"
        />
      </clipPath>
    </defs> */}
    <g
      clipPath="url(#Pills_svg__a)"
      data-name="Group 1837"
      fill="#fff"
    >
      <path
        d="M42.121 36.427a3.887 3.887 0 0 1-2.55 2.37 19.023 19.023 0 0 1-4.882 1.24 40.966 40.966 0 0 1-10.7.086 18.214 18.214 0 0 1-5.789-1.466c-.61-.293-1.168-.695-1.684-1.007a28.51 28.51 0 0 1-2.7 1.771A9.583 9.583 0 0 1 1.339 25.937Q7.4 15.417 13.489 4.909a9.406 9.406 0 0 1 8.471-4.91 9.6 9.6 0 0 1 8.1 14.558q-2.36 4.094-4.724 8.186c-.073.127-.137.258-.231.437.616-.04 1.174-.082 1.732-.111a37.214 37.214 0 0 1 10.216.774 11.732 11.732 0 0 1 3.6 1.358 3.067 3.067 0 0 1 1.474 1.842ZM22.993 23.468c.075-.111.125-.175.165-.244q2.773-4.8 5.543-9.606a7.85 7.85 0 0 0 .905-5.706 7.936 7.936 0 0 0-6.136-6.113 7.826 7.826 0 0 0-8.237 3.441c-1.8 2.942-3.479 5.959-5.21 8.944-.253.435-.5.873-.774 1.346l13.744 7.935m-14.548-6.5c-.063.082-.093.111-.113.146L2.69 26.899a7.439 7.439 0 0 0-.947 5.148 7.569 7.569 0 0 0 5.767 6.436 7.722 7.722 0 0 0 8.138-2.516 1.055 1.055 0 0 0 .282-.776c-.009-2.522.006-5.045-.012-7.567a2.269 2.269 0 0 1 .9-1.974 9.693 9.693 0 0 1 1.648-.984c.631-.293 1.309-.486 2.026-.744Zm9.126 12.68v.457c0 1.645.092 3.3-.031 4.932a1.937 1.937 0 0 0 1.441 2.193c.089.034.178.071.267.107a19.221 19.221 0 0 0 4.862 1.141 39.076 39.076 0 0 0 6.768.255 27.728 27.728 0 0 0 6.49-.928 17.21 17.21 0 0 0 2.46-1 1.127 1.127 0 0 0 .661-1.161c-.041-1.644-.014-3.289-.014-4.934v-1.073a.77.77 0 0 0-.15.034 19.085 19.085 0 0 1-6.557 1.723 39.928 39.928 0 0 1-7.634.173 26.124 26.124 0 0 1-6.81-1.23c-.577-.2-1.14-.443-1.753-.684m15.008-4.751v-.075c-.079-.011-.157-.024-.236-.031a38.657 38.657 0 0 0-7.387.069 21.43 21.43 0 0 0-5.1 1.022 9.61 9.61 0 0 0-1.67.771c-.8.479-.783.853.008 1.37a2.55 2.55 0 0 0 .573.318c1.051.343 2.1.685 3.166.984a1.258 1.258 0 0 0 .772-.078c1.573-.671 3.134-1.37 4.7-2.061l5.174-2.289M25.5 29.852c.326.031.526.054.727.068a39.5 39.5 0 0 0 6.607-.089 21.346 21.346 0 0 0 5.381-1.063 10.56 10.56 0 0 0 1.957-1c.416-.264.391-.541.011-.856a2.881 2.881 0 0 0-.823-.53q-1.522-.542-3.074-.995a1.3 1.3 0 0 0-.814.058c-3.16 1.376-6.311 2.773-9.463 4.166-.134.059-.263.127-.509.246"
        data-name="Path 4072"
      />
      <path
        d="M20.338 3.089a.826.826 0 0 1 .855.6.793.793 0 0 1-.4.9 2.372 2.372 0 0 1-.418.164 5 5 0 0 0-2.787 2.108c-.029.046-.057.093-.088.138a.826.826 0 1 1-1.384-.881 5.353 5.353 0 0 1 1.7-1.865 22.6 22.6 0 0 1 2.225-1.106.988.988 0 0 1 .295-.058"
        data-name="Path 4073"
      />
      <path
        d="M22.039 3.798a.786.786 0 0 1 .781-.824.813.813 0 0 1 .842.814.812.812 0 0 1-1.623.01"
        data-name="Path 4074"
      />
    </g>
  </svg>
);

export default SvgPills;

